<template>
  <v-progress-circular
    v-bind="circular_props"
    class="progress-circular-element"
  >
    <slot />
  </v-progress-circular>
</template>

<script>
export default {
  name: 'ProgressCircularElement',
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    color: {
      type: String,
      default: undefined,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: undefined,
    },
    width: {
      type: [Number, String],
      default: undefined,
    },
    rotate: {
      type: [Number, String],
      default: undefined,
    },
    reveal: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    circular_props() {
      return {
        ...this.$attrs,
        color: this.color,
        indeterminate: this.indeterminate,
        modelValue: this.value,
        reveal: this.reveal,
        rotate: this.rotate,
        size: this.size,
        width: this.width,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.progress-circular-element {
  flex-shrink: 0;
}
</style>
